import React from 'react';
import { MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SalovareSelectField from '../common/SalovareSelectField';
import { DASHBOARD_PERIOD_OPTIONS } from '../../utils/dashboardMetricUtils';

const DashboardPeriodSelect = ({ label, value, onChange }) => {
  const { t } = useTranslation();

  return (
    <SalovareSelectField
      label={label}
      value={value}
      onChange={(event) => onChange(event.target.value)}
    >
      {DASHBOARD_PERIOD_OPTIONS.map((period) => (
        <MenuItem key={period} value={period}>
          {t(`dashboard.periods.${period}`)}
        </MenuItem>
      ))}
    </SalovareSelectField>
  );
};

export default DashboardPeriodSelect;
